module.exports = __webpack_public_path__ + "img/03.363cda8c.jpg";